import {
  AppShell,
  Box,
  Burger,
  Button,
  Divider,
  Flex,
  Group,
  Image,
  MantineProvider, 
  Stack,
  Text, 
} from "@mantine/core";
import { useNavigate } from "react-router";
import { brandColors, theme } from "../../Theme";
import { useDisclosure } from "@mantine/hooks";
import Logo from "../Logo.component";

export function ErrorBoundary() {
  const [opened, { toggle }] = useDisclosure();  
  const navigate = useNavigate();

  return (
    <MantineProvider theme={theme}>
      <AppShell
        header={{ height: 62 }}
        padding={0}
        styles={{
          header: {
            backgroundColor: brandColors.headerBackground,
          },
        }}
      >
        <AppShell.Header>
          <Flex h="100%" justify={"space-between"} px="200px">
            <Burger
              opened={opened}
              onClick={toggle}
              id="header-burger"
              hiddenFrom="sm"
              size="sm"
            />

            <Group gap={"xl"} align="center">
              <Logo />
            </Group>
          </Flex>
        </AppShell.Header>
        <AppShell.Main
          style={{
            position: "relative",
            backgroundColor: "#F5F5F5",
            maxHeight: "calc(100vh - 62px)",
          }}
        >
          <Stack align="center" justify="center" h="calc(100vh - 62px)">
            <Group gap={"sm"} wrap="wrap">
              {/* /logo.png */}
              <Box>
                {/* <Logo /> */}
                <Image src={"/error.png"} alt="Not found 404" />
              </Box>
              <Divider orientation="vertical" />
              <Stack ps={50} gap={5}>
                <Text size="sm" c={"#5F6368"}>
                  Error code: 404
                </Text>
                <Text fw={600} fz={"57.42px"} lh={"69.49px"} c={"#000000"}>
                  OOOPS!!
                </Text>
                <Text size="md" c={"#5F6368"}>
                  This is not the page you are looking for
                </Text>
                <Button
                  mt={"md"}
                  variant="filled"
                  style={{ borderRadius: "0px", width: "max-content" }}
                  onClick={() => navigate("/")}
                >
                  Home Page
                </Button>
              </Stack>
            </Group>
          </Stack>
        </AppShell.Main>
      </AppShell>
    </MantineProvider>
  );
}
